var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfactionicon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 106,
    viewBox: "0 0 150 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1323 104.868L43.4779 93.8382L21.5073 49.3235L-0.838257 60.3529L21.1323 104.868ZM23.7132 82.1911C27.0662 80.5367 31.2132 81.9264 32.8676 85.3014C34.522 88.6544 33.1323 92.8014 29.7573 94.4558C26.4044 96.1103 22.2573 94.7205 20.6029 91.3455C18.9485 87.9926 20.3603 83.8455 23.7132 82.1911Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6102 92.0954C30.5955 91.1248 31.5882 88.6542 30.5073 86.4704C29.4264 84.2866 26.8676 83.5807 24.8823 84.5733C22.897 85.566 21.9044 88.0145 22.9852 90.1983C24.0661 92.3601 26.6249 93.066 28.6102 92.0954Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.596 57.9484L105.949 70.3675C100.5 72.8161 94.7868 73.169 89.8676 71.669L67.6985 67.6102C62.0735 66.7058 61.4118 63.8381 61.4118 62.3602C61.5221 60.0881 63.3971 57.9264 64.7868 57.7499C64.7868 57.7499 64.9853 57.6617 65.0735 57.8602L93.0662 61.2573C97.6103 60.9925 99.5956 59.5146 100.39 55.169C100.5 54.3749 100.39 53.6911 99.9044 53.1837C98.625 51.5955 95.3824 50.9999 93.3971 50.9778C93.3971 50.9778 93.3971 50.9778 93.1985 51.0661L56.0515 43.5881L27.4853 55.9852L40.5882 82.4778C47.4044 79.8528 53.3382 78.8822 58.1471 80.1837L88.8088 85.9631C93.1544 86.7793 97.6985 86.0072 102.044 83.8455L134.074 68.0073C137.25 66.4411 138.044 61.6102 136.985 59.4484C135.816 57.0881 132.551 56.4705 129.596 57.9484Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2647 -1.03687L102.463 8.82343H112.853L104.449 14.9117L107.647 24.794L99.2647 18.6837L90.8823 24.794L94.0809 14.9117L85.6765 8.82343H96.0662L99.2647 -1.03687Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9706 -1.03687L67.1691 8.82343H77.5588L69.1544 14.9117L72.3529 24.794L63.9706 18.6837L55.5882 24.794L58.7867 14.9117L50.3823 8.82343H60.772L63.9706 -1.03687Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.765 -1.03687L139.963 8.82343H150.353L141.949 14.9117L145.147 24.794L136.765 18.6837L128.382 24.794L131.581 14.9117L123.176 8.82343H133.566L136.765 -1.03687Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0294 23.2278L89.2279 33.0881H99.6176L91.2132 39.1763L94.4118 49.0587L86.0294 42.9484L77.647 49.0587L80.8456 39.1763L72.4412 33.0881H82.8309L86.0294 23.2278Z",
    fill: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.118 23.2278L122.316 33.0881H132.706L124.301 39.1763L127.5 49.0587L119.118 42.9484L110.735 49.0587L113.934 39.1763L105.529 33.0881H115.919L119.118 23.2278Z",
    fill: "#FCFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 105.882,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionicon02);
export default __webpack_public_path__ + "static/media/satisfactionicon-02.9c1912cc2e1c756c68e751bceb3186b8.svg";
export { ForwardRef as ReactComponent };